import styled from 'styled-components';
import { Layout, Typography, Avatar } from 'antd';

const { Header } = Layout;
const { Title } = Typography;

const StyledHeader = styled(Header)`
  &&& {
    background-color: #0078d4;
    padding: 0 32px;
    min-width: max-content;
    height: 50px;
    line-height: 50px;
  }
`;

const StyledTitle = styled(Title)`
  &&& {
    margin: auto 20px;
    color: white;
    font-weight: normal;
  }
`;

const StyledAvatar = styled(Avatar)`
  &&& {
    background-color: #87d068;
    margin-bottom: 6px;
  }
`;

export { StyledHeader, StyledTitle, StyledAvatar };
